import AddIcon from "@mui/icons-material/Add";
import { default as CancelIcon, default as CloseIcon } from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
import "./Index.css";
import {
  Avatar,
  Badge,
  Card,
  CardContent,
  Checkbox,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Typography
} from "@mui/material";
import { styled } from "@mui/material/styles";
import {
  DataGrid,
  GridActionsCellItem,
  GridRowEditStopReasons,
  GridRowModes,
  GridToolbarContainer
} from "@mui/x-data-grid";
import axios from "axios";
import Swal from "sweetalert2";
import { ProgramOptions, ExerciseOptions } from "./DayScheduleResources";
import ReactPlayer from "react-player";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1
});

const EquipmentsDetailsModal = ({ open, onClose, details }) => {
  if (!details || details.length === 0) return null;
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          maxHeight: "80vh",
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: 4,
          overflow: "hidden",
          padding: 2
        }}
      >
        <Card sx={{ minWidth: 275 }}>
          <CardContent>
            {details.map((equipment, index) => (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <img src={`${equipment.icon}`} height="25" width="25" />
                <Typography key={index} component="div">
                  {equipment.name}
                </Typography>
              </Box>
            ))}
          </CardContent>
        </Card>
      </Box>
    </Modal>
  );
};

const ExercisesDetailsModal = ({ open, onClose, details }) => {
  if (!details || details.length === 0) return null;
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          maxHeight: "80vh",
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: 4,
          overflow: "hidden",
          padding: 2
        }}
      >
        <Card sx={{ maxHeight: "70vh", overflowY: "auto" }}>
          <CardContent>
            {details.map((exercise, index) => (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column"
                }}
              >
                <Box>
                  <Box>{exercise.name}</Box>
                </Box>
                <ReactPlayer
                  url={`${exercise.gif}`}
                  playing={true}
                  loop={true}
                  controls={true}
                  height={320}
                  width="100%"
                  style={{ borderRadius: "30px", overflow: "hidden" }}
                />
              </Box>
            ))}
          </CardContent>
        </Card>
      </Box>
    </Modal>
  );
};

const appColor = "#59D6DF";
const initialRows = [];
const apiBaseURL = process.env.REACT_APP_API_BASE_URL;
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4
};

function EditToolbar(props) {
  const {
    setRows,
    setRowModesModel,
    addedUser,
    setAddedUser,
    showToolbar,
    setShowToolbar,
    selectedSchedule,
    setSelectedSchedule
  } = props;
  const [open, setOpen] = React.useState(false);
  const [id, setId] = useState("");
  const [programOptions, setProgramOptions] = useState([]);
  const [selectProgram, setSelectProgram] = useState("");
  const [exerciseOptions, setExerciseOptions] = useState([]);
  const [selectExercise, setSelectExercise] = useState([]);
  const [selectDays, setSelectDays] = useState([]);
  const [daysOption, setDaysOptions] = useState([]);
  const [email, setEmail] = useState("");
  const [clickedClosed, setClickClosed] = useState(false);

  const [programError, setProgramError] = useState("");
  const [daysError, setDaysError] = useState("");
  const [exerciseError, setExerciseError] = useState("");

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250
      }
    }
  };

  const handleOpen = () => setOpen(true);

  const handleClose = () => {
    setOpen(false);
    setShowToolbar(false);
    setSelectedSchedule({});
    setClickClosed(!clickedClosed);
    setSelectProgram("");
    setExerciseOptions([]);
    setProgramOptions([]);
    setDaysOptions([]);
    setSelectDays([]);
    setSelectExercise([]);
    setDaysError("");
    setProgramError("");
    setExerciseError("");
  };

  useEffect(() => {
    ProgramOptions().then((value) => {
      setProgramOptions(value);
    });
    ExerciseOptions().then((value) => {
      setExerciseOptions(value);
    });
    setOpen(showToolbar);
    if (Object.keys(selectedSchedule).length) {
      console.log(selectedSchedule, "selectedSchedule");
      setId(selectedSchedule.id || "");
      setSelectProgram(selectedSchedule.programId);
      const findProgramDays = programOptions.find(
        (value) => value.id == selectedSchedule.programId
      );
      const totalDays = findProgramDays.days;
      const restDaysArr = findProgramDays.restDays;
      const addedDaysArr = findProgramDays.addedDays.map((value) => {
        return value.day;
      });
      const neglectDaysArr = [...restDaysArr, ...addedDaysArr];
      const totalDaysArr = Array.from({ length: totalDays }, (_, index) => index + 1);
      const daysArr = totalDaysArr.filter((value) => {
        if (!neglectDaysArr.includes(value)) {
          return true;
        }
      });
      setDaysOptions([selectedSchedule.day, ...daysArr]);
      setSelectDays([selectedSchedule.day]);
      const addedExercises = Array.isArray(selectedSchedule.exercises)
        ? selectedSchedule.exercises.map((value) => {
          return value.exerciseId;
        })
        : [];
      setSelectExercise(addedExercises);
    } else {
      setId("");
      setSelectProgram("");
      setDaysOptions([]);
      setSelectDays([]);
      setSelectExercise([]);
    }
  }, [showToolbar, selectedSchedule]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectProgram == "") {
      setProgramError("Program is required!");
    } else if (selectProgram && daysOption.length === 0) {
      setDaysError("No days are left to be scheduled in this program");
    } else if (!selectDays.length) {
      setDaysError("Please select days to add schedule.");
    } else if (!selectExercise.length) {
      setExerciseError("Please select exercise for schedule!");
    } else {
      const headers = {
        "Content-Type": "application/json",
        "x-access-token": `${localStorage.getItem("token")}`
      };
      axios
        .post(
          `${apiBaseURL}/api/v1/admin/addupdateschedule`,
          { id, selectProgram, selectDays, selectExercise },
          {
            headers: headers
          }
        )
        .then((res) => {
          if (res.data) {
            setOpen(false);
            setShowToolbar(false);
            setAddedUser(!addedUser);
            setSelectedSchedule({});
            const { message } = res.data;
            Swal.fire({
              position: "center",
              icon: "success",
              title: `${message}`,
              showConfirmButton: false,
              timer: 1000
            });
          }
        })
        .catch((error) => {
          setOpen(false);
          setShowToolbar(false);
          setAddedUser(!addedUser);
          setSelectedSchedule({});
          const { message } = error.response.data;
          Swal.fire({
            icon: "error",
            title: "Error",
            text: message
          });
        });
    }
  };

  return (
    <GridToolbarContainer sx={{ justifyContent: "flex-end" }}>
      <Button
        sx={{ color: "#59D6DF", border: "1px solid grey" }}
        startIcon={<AddIcon />}
        onClick={handleOpen}
      >
        Add Schedule
      </Button>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500
          }
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={(theme) => ({
                position: "absolute",
                right: 5,
                top: 5,
                color: theme.palette.grey[500]
              })}
            >
              <CloseIcon />
            </IconButton>
            <form autoComplete="off" onSubmit={handleSubmit}>
              <Box mb={2}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Select Programs</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    fullWidth
                    value={selectProgram}
                    onChange={(event) => {
                      setSelectProgram(event.target.value);
                      const findProgramDays = programOptions.find(
                        (value) => value.id == event.target.value
                      );
                      const totalDays = findProgramDays.days;
                      const restDaysArr = findProgramDays.restDays;
                      const addedDaysArr = findProgramDays.addedDays.map((value) => {
                        return value.day;
                      });
                      const neglectDaysArr = [...restDaysArr, ...addedDaysArr];
                      const totalDaysArr = Array.from(
                        { length: totalDays },
                        (_, index) => index + 1
                      );
                      const daysArr = totalDaysArr.filter((value) => {
                        if (!neglectDaysArr.includes(value)) {
                          return true;
                        }
                      });
                      setDaysOptions(daysArr);
                      // Set error message if no days are available
                      if (daysArr.length === 0) {
                        setDaysError("No days are left to be scheduled in this program");
                      } else {
                        setDaysError("");
                      }
                    }}
                    defaultValue={selectProgram}
                    label="Select Programs"
                    sx={{ height: "45px" }}
                    endAdornment={
                      <InputAdornment
                        position="end"
                        sx={{ height: "100%", alignItems: "center", fontSize: "x-large" }}
                      >
                        <KeyboardArrowDownIcon />
                      </InputAdornment>
                    }
                    MenuProps={MenuProps}
                  >
                    {programOptions.map((option) => (
                      <MenuItem sx={{ height: "45px" }} key={option.id} value={option.id}>
                        {option.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <InputLabel sx={{ pt: 1, color: "red" }}>{programError}</InputLabel>
              </Box>
              <Box mb={2}>
                <FormControl fullWidth>
                  <InputLabel id="demo-multiple-checkbox-label">Select Days</InputLabel>
                  <Select
                    labelId="demo-multiple-checkbox-label"
                    multiple
                    fullWidth
                    value={selectDays}
                    input={<OutlinedInput label="Select Days" />}
                    onChange={(event) => {
                      setSelectDays(event.target.value);
                    }}
                    renderValue={(selected) =>
                      selected
                        .map((value) => {
                          const option = exerciseOptions.find((opt) => opt === value);
                          return option ? option : value;
                        })
                        .join(", ")
                    }
                    sx={{ height: "45px" }}
                    endAdornment={
                      <InputAdornment
                        position="end"
                        sx={{
                          height: "100%",
                          alignItems: "center",
                          fontSize: "x-large",
                          pointerEvents: "none"
                        }}
                      >
                        <KeyboardArrowDownIcon />
                      </InputAdornment>
                    }
                    MenuProps={MenuProps}
                    disabled={daysOption.length === 0}
                  >
                    {daysOption.map((option) => (
                      <MenuItem key={option} value={option}>
                        <Checkbox checked={selectDays.indexOf(option) > -1} />
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <InputLabel sx={{ pt: 1, color: daysOption.length === 0 ? "orange" : "red" }}>
                  {daysError}
                </InputLabel>
              </Box>
              <Box mb={2}>
                <FormControl fullWidth>
                  <InputLabel id="demo-multiple-checkbox-label">Select Exercises</InputLabel>
                  <Select
                    labelId="demo-multiple-checkbox-label"
                    multiple
                    fullWidth
                    value={selectExercise}
                    input={<OutlinedInput label="Select Exercises" />}
                    onChange={(event) => {
                      setSelectExercise(event.target.value);
                    }}
                    renderValue={(selected) =>
                      selected
                        .map((value) => {
                          const option = exerciseOptions.find((opt) => opt.id === value);
                          return option ? option.name : value;
                        })
                        .join(", ")
                    }
                    sx={{ height: "45px" }}
                    endAdornment={
                      <InputAdornment
                        position="end"
                        sx={{
                          height: "100%",
                          alignItems: "center",
                          fontSize: "x-large",
                          pointerEvents: "none"
                        }}
                      >
                        <KeyboardArrowDownIcon />
                      </InputAdornment>
                    }
                    MenuProps={MenuProps}
                  >
                    {exerciseOptions.map((option) => (
                      <MenuItem key={option.name} value={option.id}>
                        <Checkbox checked={selectExercise.indexOf(option.id) > -1} />
                        {option.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <InputLabel sx={{ pt: 1, color: "red" }}>{exerciseError}</InputLabel>
              </Box>
              <Box mt={4} mb={1}>
                <Button
                  variant="contained"
                  type="submit"
                  sx={{
                    backgroundColor: appColor,
                    color: "#FFFFFF",
                    ":hover": {
                      backgroundColor: appColor
                    }
                  }}
                  fullWidth
                >
                  Register Schedule
                </Button>
              </Box>
            </form>
          </Box>
        </Fade>
      </Modal>
    </GridToolbarContainer>
  );
}

const DaySchedule = () => {
  const [rows, setRows] = React.useState(initialRows);
  const [addedUser, setAddedUser] = useState(false);
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [calledBlockUser, setCallBlockUser] = useState(false);
  const [profilePic, setProfilePic] = React.useState({});
  const [calledUpdateUser, setCallUpdateUser] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpenExercise, setModalOpenExercise] = useState(false);
  const [selectedEquipmentsDetails, setSelectedEquipmentsDetails] = useState(null);
  const [selectedExercisesDetails, setSelectedExercisesDetails] = useState(null);
  const [selectedSchedule, setSelectedSchedule] = React.useState({});
  const [showToolbar, setShowToolbar] = React.useState(false);
  const [searchBy, setSearchBy] = useState("");
  const [debouncedSearchBy, setDebouncedSearchBy] = useState("");

  // Pagination state
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10
  });
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);

  // Debounce search
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchBy(searchBy);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchBy]);

  // Reset pagination when search changes
  useEffect(() => {
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  }, [debouncedSearchBy]);

  const handleOpenModal = (details) => {
    setSelectedEquipmentsDetails(details);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setSelectedEquipmentsDetails(null);
    setModalOpen(false);
  };

  const handleOpenModalExercise = (details) => {
    setSelectedExercisesDetails(details);
    setModalOpenExercise(true);
  };

  const handleCloseModalExercise = () => {
    setSelectedExercisesDetails(null);
    setModalOpenExercise(false);
  };

  function formatIdealTime(idealTime) {
    if (!idealTime) return "0 mins";

    const timeInSeconds = parseInt(idealTime, 10);
    if (isNaN(timeInSeconds) || timeInSeconds <= 0) return "0 mins";

    const minutes = Math.floor(timeInSeconds / 60);
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    if (hours > 0 && remainingMinutes > 0) {
      return `${hours} hrs ${remainingMinutes} mins`;
    } else if (hours > 0) {
      return `${hours} hrs`;
    } else {
      return `${minutes} mins`;
    }
  }

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const headers = {
          "Content-Type": "application/json",
          "x-access-token": `${localStorage.getItem("token")}`
        };
        const scheduleList = await axios.post(
          `${apiBaseURL}/api/v1/admin/getschedule`,
          {
            searchBy: debouncedSearchBy,
            page: paginationModel.page + 1, // API expects 1-based page numbers
            pageSize: paginationModel.pageSize
          },
          {
            headers: headers
          }
        );
        if (scheduleList.data) {
          const { schedules, total, currentPage, totalPages } = scheduleList.data.data;
          const currentRows = schedules.map((value, index) => {
            return {
              id: value?._id,
              name: value?.programId?.name,
              day: value?.day,
              idealTime: formatIdealTime(value?.idealTime),
              exercises: value?.exercises?.length ? value?.exercises : null,
              equipments: value?.equipments?.length ? value?.equipments : null,
              programId: value?.programId?._id
            };
          });
          setRows(currentRows);
          setTotalRows(total || schedules.length);
        }
      } catch (error) {
        console.error("Error fetching schedules:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to fetch schedules. Please try again."
        });
      } finally {
        setLoading(false);
      }
    })();
  }, [
    addedUser,
    calledBlockUser,
    calledUpdateUser,
    debouncedSearchBy,
    paginationModel.page,
    paginationModel.pageSize
  ]);

  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleDeleteClick = (id) => {
    Swal.fire({
      title: `Are you sure you want to delete this schedule?`,
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonColor: appColor
    })
      .then(async (result) => {
        if (result.isConfirmed) {
          try {
            const headers = {
              "Content-Type": "application/json",
              "x-access-token": `${localStorage.getItem("token")}`
            };
            const deleteSchedule = await axios.delete(`${apiBaseURL}/api/v1/admin/deleteschedule`, {
              headers: headers,
              data: {
                id
              }
            });
            if (deleteSchedule.data) {
              Swal.fire("The schedule is deleted now!", "", "success");
              setRows(rows.filter((row) => row.id !== id));
            }
          } catch (error) {
            console.log(error, "error");
            const { message } = error.response.data;
            Swal.fire({
              icon: "error",
              title: "Error",
              text: message
            });
          }
        } else if (result.isDenied) {
          Swal.fire("Changes are not saved", "", "info");
        }
      })
      .catch((error) => {
        console.log(error, "error");
      });
  };

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const handlePaginationModelChange = (newPaginationModel) => {
    setPaginationModel(newPaginationModel);
  };

  const handleFileChange = (e, params) => {
    const file = e.target.files[0];
    if (file) {
      const updatedRow = {
        ...params.row,
        // profilePic: `<img src="${URL.createObjectURL(file)}" />`,?
        profilePic: file
      };
      setProfilePic(updatedRow.profilePic);
      setRows((prevRows) => prevRows.map((row) => (row.id === params.id ? updatedRow : row)));
    }
  };

  const columns = [
    { field: "name", headerName: "Program Name", width: 210, sortable: false },
    {
      field: "day",
      headerName: "Day",
      type: "number",
      width: 150,
      sortable: false
    },
    {
      field: "exercises",
      headerName: "Exercises",
      width: 150,
      sortable: false,
      renderCell: (params) =>
        params.row.exercises ? (
          <IconButton
            sx={{ left: -30 }}
            onClick={() => handleOpenModalExercise(params.row.exercises)}
          >
            <Button href="#text-buttons" style={{ textTransform: "none" }}>
              View Exercise
            </Button>
          </IconButton>
        ) : (
          "N/A"
        )
    },
    {
      field: "idealTime",
      headerName: "Ideal Time",
      width: 150,
      sortable: false
    },
    {
      field: "equipments",
      headerName: "Equipments",
      sortable: false,
      width: 280,
      renderCell: (params) =>
        params.row.equipments ? (
          <IconButton sx={{ left: -30 }} onClick={() => handleOpenModal(params.row.equipments)}>
            <Button href="#text-buttons" style={{ textTransform: "none" }}>
              View Equipments(Based on selected exercises)
            </Button>
          </IconButton>
        ) : (
          "N/A"
        )
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      sortable: false,
      width: 200,
      cellClassName: "actions",
      getActions: (params) => {
        const id = params.row.id;
        // if (isInEditMode) {
        //   return [
        //     <GridActionsCellItem
        //       icon={<SaveIcon />}
        //       label="Save"
        //       sx={{
        //         color: "primary.main"
        //       }}
        //       onClick={() => {
        //         handleSaveClick(id);
        //       }}
        //     />,
        //     <GridActionsCellItem
        //       icon={<CancelIcon />}
        //       label="Cancel"
        //       className="textPrimary"
        //       onClick={() => {
        //         handleCancelClick(id);
        //       }}
        //       color="inherit"
        //     />
        //   ];
        // }
        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={() => {
              setShowToolbar(true);
              setSelectedSchedule(params.row);
            }}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={() => {
              handleDeleteClick(id);
            }}
            color="inherit"
          />
        ];
      }
    }
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box sx={{ width: "100%", marginBottom: 2 }}>
        <TextField
          id="outlined-basic"
          label="Search by Program Name or Day"
          variant="outlined"
          value={searchBy}
          onChange={(event) => {
            setSearchBy(event.target.value);
          }}
          sx={{
            width: "300px"
          }}
        />
      </Box>
      <Box
        sx={{
          height: 675,
          width: "100%",
          "& .actions": {
            color: "text.secondary"
          },
          "& .textPrimary": {
            color: "text.primary"
          }
        }}
      >
        <DataGrid
          rows={rows}
          columns={columns}
          disableColumnResize
          disableColumnMenu
          editMode="row"
          rowModesModel={rowModesModel}
          onRowModesModelChange={handleRowModesModelChange}
          onRowEditStop={handleRowEditStop}
          slots={{
            toolbar: EditToolbar
          }}
          // Server-side pagination
          paginationMode="server"
          paginationModel={paginationModel}
          onPaginationModelChange={handlePaginationModelChange}
          rowCount={totalRows}
          pageSizeOptions={[10, 20, 30, 50]}
          loading={loading}
          sx={{
            fontFamily: `"Roboto","Helvetica","Arial",sans-serif`,
            fontWeight: 400,
            "& .MuiDataGrid-columnHeader": {
              borderRight: "1px solid rgba(224, 224, 224, 1)"
            },
            "& .MuiDataGrid-cell": {
              borderRight: "1px solid rgba(224, 224, 224, 1)"
            },
            "& .MuiDataGrid-row": {
              backgroundColor: "#fff",
              "&:nth-of-type(odd)": {
                backgroundColor: "#f9f9f9"
              }
            },
            "& .MuiDataGrid-cell:focus, & .MuiDataGrid-row:focus": {
              outline: "none"
            },
            "& .MuiDataGrid-cell:focus-within": {
              outline: "none"
            },
            "& .Mui-selected": {
              backgroundColor: "inherit !important"
            },
            "& .MuiDataGrid-columnHeader": {
              "& .MuiDataGrid-iconButtonContainer": {
                display: "none"
              },
              "& .MuiDataGrid-menuIcon": {
                display: "none"
              }
            }
          }}
          localeText={{ noRowsLabel: "No Schedule is available" }}
          slotProps={{
            toolbar: {
              setRows,
              setRowModesModel,
              addedUser,
              setAddedUser,
              showToolbar,
              setShowToolbar,
              selectedSchedule,
              setSelectedSchedule
            }
          }}
        />
        <ExercisesDetailsModal
          open={modalOpenExercise}
          onClose={handleCloseModalExercise}
          details={selectedExercisesDetails}
        />
        <EquipmentsDetailsModal
          open={modalOpen}
          onClose={handleCloseModal}
          details={selectedEquipmentsDetails}
        />
      </Box>
    </DashboardLayout>
  );
};

export default DaySchedule;
